import { createGraphqlBaseApi, resolveGraphqlUrl } from '@vipso/shared';
import { logout, setTokens } from './authSlice';

type AuthStateSlice = {
  auth: {
    accessToken: string | null;
    refreshToken: string | null;
  };
};

const REFRESH_MUTATION = `
  mutation SystemAdminRefresh($refreshToken: String!) {
    systemAdminRefresh(refreshToken: $refreshToken) {
      accessToken
      refreshToken
    }
  }
`;

export const baseApi = createGraphqlBaseApi({
  url: resolveGraphqlUrl(),
  reducerPath: 'adminApi',
  tagTypes: [
    'Tenant',
    'Org',
    'SystemAdmin',
    'AuditLog',
    'Feature',
    'Task',
    'Billing',
  ] as const,
  refreshMutation: REFRESH_MUTATION,
  refreshPayloadKey: 'systemAdminRefresh',
  getTokens: (state) => ({
    accessToken: (state as AuthStateSlice).auth.accessToken,
    refreshToken: (state as AuthStateSlice).auth.refreshToken,
  }),
  setTokens,
  logout,
});
